var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      attrs: {
        errors: _vm.errors,
        needHelp: false,
        bgGradient: "",
        img: null,
        breadcrumbs: ["Home", "Student Survey"],
      },
    },
    [
      _c(
        "v-col",
        {
          staticClass: "white--text text-center px-0",
          attrs: { cols: "12", sm: "10", md: "8", lg: "6" },
        },
        [
          _c("StudentSurveyForm", {
            attrs: {
              errors: _vm.errors,
              user: _vm.user,
              hearAboutUsOptions: _vm.hearAboutUsOptions,
              importantOptions: _vm.importantOptions,
              locationUserId: _vm.locationUserId,
              teacher: _vm.teacher,
              source: _vm.source,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }